
export const STORE_PUBLISH_FIELD_DETAILS = `STORE_PUBLISH_FIELD_DETAILS`

export const storePublishFieldDetails = (payload:any): any => {
	return {
		type: STORE_PUBLISH_FIELD_DETAILS,
		payload
	}
}